import type { ButtonProps } from '@mui/material';
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  styled,
  tooltipClasses,
} from '@mui/material';
import isNullOrUndefined from '@utils/isNullOrUndefined';
import { memo, useMemo } from 'react';

type Props = ButtonProps &
  Partial<{
    progress: boolean;
    tooltipTitle: string | React.ReactNode;
  }>;

const ProgressButton: React.FC<Props> = ({
  progress = false,
  tooltipTitle = undefined,
  disabled,
  ...rest
}: Props) => {
  const button = useMemo(
    () =>
      isNullOrUndefined(tooltipTitle) || disabled ? (
        <Button disabled={disabled} {...rest} />
      ) : (
        <StyledTooltip arrow title={tooltipTitle} placement="top">
          <Button disabled={disabled} {...rest} />
        </StyledTooltip>
      ),
    [tooltipTitle, rest, disabled],
  );

  return (
    <WrapperBox>
      {button}
      {progress && <Progress size={24} />}
    </WrapperBox>
  );
};

export default memo(ProgressButton);

const WrapperBox = styled(Box)`
  position: relative;
`;

const Progress = styled(CircularProgress)`
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -12px;
  margin-left: -12px;
`;

const StyledTooltip = styled(Tooltip)`
  ${tooltipClasses.tooltip} {
    max-width: 200;
    text-align: center;
  }
`;
